import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import Pagination from 'react-js-pagination'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import 'bootstrap/dist/css/bootstrap.min.css'
import IMG_1_3 from 'assets/images/customer/customer-egcare-service-mobile-img-1.png'
import IMG_2_3 from 'assets/images/customer/customer-egcare-service-mobile-img-2.png'
import IMG_3_3 from 'assets/images/customer/customer-egcare-service-mobile-img-3.png'
import IMG_4_3 from 'assets/images/customer/customer-egcare-service-mobile-img-4.png'
import IMG_5_1 from 'assets/images/customer/warranty-extension-chart-pc.png'
import IMG_5_2 from 'assets/images/customer/warranty-extension-chart-pad.png'
import IMG_5_3 from 'assets/images/customer/warranty-extension-chart-mobile.png'

/* tableimg */
import IMG_6_1 from 'assets/images/customer/new-warranty-2-pc.png'
import IMG_6_2 from 'assets/images/customer/new-warranty-2-pad.png'
import IMG_6_3 from 'assets/images/customer/new-warranty-2-pc.png'

import IMG_7_1 from 'assets/images/customer/parts-warranty-pc.png'
import IMG_7_2 from 'assets/images/customer/parts-warranty-pad.png'
import IMG_7_3 from 'assets/images/customer/parts-warranty-mobile.png'

import IMG_8_1 from 'assets/images/customer/periodic-inspection-2-pc.png'
import IMG_8_2 from 'assets/images/customer/periodic-inspection-2-pc.png'
import IMG_8_3 from 'assets/images/customer/periodic-inspection-2-pc.png'

import IMG_9_1 from 'assets/images/customer/periodic-inspection-details-pc.png'
import IMG_9_2 from 'assets/images/customer/periodic-inspection-details-pad.png'
import IMG_9_3 from 'assets/images/customer/periodic-inspection-details-mobile.png'

import IMG_10_1 from 'assets/images/customer/price-table-pc.png'
import IMG_10_2 from 'assets/images/customer/price-table-pad.png'
import IMG_10_3 from 'assets/images/customer/price-table-mobile.png'

import { COMPANY_NAME_KO, PARTS_BIKE_DATA } from '../../utils/Utils'
import { priceToString, nullReturn, isEmpty } from '../../utils/UtilsFunction'
import CustomerTitle from './components/CustomerTitle'
import CustomerMain from './CustomerMain'
import './CustomerEgcare.scss'
import './CustomerMain.scss'

/**
 * @file [고객지원]-[EG CARE] 화면
 */
function CustomerEgcare() {
    const [paginationData, setPaginationData] = useState({
        activePage: 1, //현재 페이지
        totalItemsCount: 0, //data 총 갯수
        selectBikeType: PARTS_BIKE_DATA[0]?.BIKE_TYPE, //바이크타입
        searchIdx: 0, //검색구분 index (SP:내용, IC:부품번호, IN:부품명)
        searchKeyword: '', //검색어
        data: [], //api에서 주는 data 값
    })
    const firstImgRef = useRef()
    const secondImgRef = useRef()
    const thirdImgRef = useRef()
    const fourthImgRef = useRef()
    const partsSearchOptions = [
        { value: 'SP', label: '내용' },
        { value: 'IC', label: '부품번호' },
        { value: 'IN', label: '부품명' },
    ] //부품검색구분

    useEffect(() => {
        getPartsList()
    }, [paginationData?.activePage, paginationData?.selectBikeType])

    //부품 리스트 api
    const getPartsList = () => {
        axios
            .get(`${process.env.REACT_APP_BASE_ADMIN_URL}/homepage/parts`, {
                params: {
                    prc_gbn: 1, //1 : 부품정보 조회, 2 : 차종코드조회
                    bike_type: paginationData?.selectBikeType,
                    row_size: 15,
                    current_page: paginationData.activePage,
                    search: partsSearchOptions[paginationData.searchIdx].value, //검색구분
                    search_keyword: paginationData.searchKeyword, //검색어
                },
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                console.log('response : ', response)
                if (response?.data?.code === '00') {
                    //setRateData([...response?.data?.data])
                    let _data =
                        isEmpty(response?.data?.data) || response?.data?.data?.length < 1
                            ? []
                            : [...response?.data?.data]
                    setPaginationData({
                        ...paginationData,
                        activePage: paginationData.activePage,
                        totalItemsCount: response?.data?.totalCount,
                        data: _data,
                    })
                } else {
                    setPaginationData({
                        ...paginationData,
                        selectBikeType: PARTS_BIKE_DATA[0]?.BIKE_TYPE,
                        activePage: 0,
                        totalItemsCount: 0,
                        searchIdx: 0,
                        searchKeyword: '',
                        data: [],
                    })
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    setPaginationData({
                        ...paginationData,
                        selectBikeType: PARTS_BIKE_DATA[0]?.BIKE_TYPE,
                        activePage: 0,
                        totalItemsCount: 0,
                        searchIdx: 0,
                        searchKeyword: '',
                        data: [],
                    })
                }
            })
    }

    //부품가격 테이블의 bike type select
    const partsBikeTypeClick = e => {
        setPaginationData({
            ...paginationData,
            selectBikeType: PARTS_BIKE_DATA[e.target.selectedIndex].BIKE_TYPE,
            activePage: 1,
        })
    }

    //부품가격 테이블의 pagination select
    const paginationOnChnage = idx => {
        setPaginationData({ ...paginationData, activePage: idx })
    }

    //부품가격 테이블의 검색 select
    const partsSearchSelect = e => {
        setPaginationData({ ...paginationData, activePage: 1, searchIdx: e.target.selectedIndex })
    }

    //부품가격 테이블의 검색 input
    const partsSearchInputChange = e => {
        setPaginationData({ ...paginationData, activePage: 1, searchKeyword: e.target.value })
    }

    //부품가격 테이블의 검색 input
    const partsSearchInputKeyDown = e => {
        if (e.key === 'Enter') {
            getPartsList()
        }
    }

    //부품가격 테이블의 검색 click
    const partsSearchClick = () => {
        getPartsList()
    }

    return (
        <>
            <CustomerMain />
            <div className="customer-body-wrap">
                <div className="customer-egcare-wrap-one">
                    <CustomerTitle
                        title="EG CARE"
                        sub="가까운 곳 어디서나 쉽고 편리하게 닷스테이션의 서비스를 이용할 수 있습니다.<br/>
                        EG CARE가 제공하는 서비스는 아래와 같습니다."
                    />
                    <div className="customer-egcare-item-wrap">
                        <div
                            className="customer-egcare-item-box"
                            onClick={() => firstImgRef.current.scrollIntoView({ behavior: 'smooth' })}>
                            <img src={IMG_1_3} className="customer-egcare-item-img pc" alt="품질보증" />
                            <img src={IMG_1_3} className="customer-egcare-item-img pad" alt="품질보증" />
                            <img src={IMG_1_3} className="customer-egcare-item-img mobile" alt="품질보증" />
                            <div className="customer-egcare-item-title">품질보증</div>
                        </div>
                        <div
                            className="customer-egcare-item-box"
                            onClick={() => secondImgRef.current.scrollIntoView({ behavior: 'smooth' })}>
                            <img src={IMG_2_3} className="customer-egcare-item-img pc" alt="정기점검" />
                            <img src={IMG_2_3} className="customer-egcare-item-img pad" alt="정기점검" />
                            <img src={IMG_2_3} className="customer-egcare-item-img mobile" alt="정기점검" />
                            <div className="customer-egcare-item-title">정기점검</div>
                        </div>
                        <div
                            className="customer-egcare-item-box"
                            onClick={() => thirdImgRef.current.scrollIntoView({ behavior: 'smooth' })}
                            ref={firstImgRef}>
                            <img src={IMG_3_3} className="customer-egcare-item-img pc" alt="표준공임" />
                            <img src={IMG_3_3} className="customer-egcare-item-img pad" alt="표준공임" />
                            <img src={IMG_3_3} className="customer-egcare-item-img mobile" alt="표준공임" />
                            <div className="customer-egcare-item-title">표준공임</div>
                        </div>
                        <div
                            className="customer-egcare-item-box"
                            onClick={() => fourthImgRef.current.scrollIntoView({ behavior: 'smooth' })}>
                            <img src={IMG_4_3} className="customer-egcare-item-img pc" alt="표준부품가격" />
                            <img src={IMG_4_3} className="customer-egcare-item-img pad" alt="표준부품가격" />
                            <img src={IMG_4_3} className="customer-egcare-item-img mobile" alt="표준부품가격" />
                            <div className="customer-egcare-item-title">표준부품가격</div>
                        </div>
                    </div>
                </div>
                <div className="customer-egcare-wrap-two">
                    <CustomerTitle
                        title="품질보증"
                        sub="품질보증이란 닷스테이션을 통하여 구매한 제품이 약정한 기간 동안<br/>
                        제조상 불량이나 정상적인 사용 중 문제가 발생할 경우, 무상수리 서비스를 시행하는 제도입니다."
                    />
                    <div className="customer-egcare-table-wrap">
                        <div className="customer-egcare-table-title">1. 보증기간 및 범위</div>
                        <div className="customer-egcare-table-box">
                            <img className="customer-egcare-price-table-img pc" src={IMG_6_1} alt="신차보증 표" />
                            <img className="customer-egcare-price-table-img pad" src={IMG_6_2} alt="신차보증 표" />
                            <img className="customer-egcare-price-table-img mobile" src={IMG_6_3} alt="신차보증 표" />
                            {/* <table className="customer-egcare-table">
                                <tbody>
                                    <tr>
                                        <th>보증차량</th>
                                        <th>보증기간</th>
                                        <th>보증대상</th>
                                    </tr>
                                    <tr>
                                        <td>Gogoro 신차</td>
                                        <td>차량 출고일로부터 3년 이내 또는 주행거리 30,000km 이하</td>
                                        <td>모든부품</td>
                                    </tr>
                                </tbody>
                            </table> */}
                        </div>
                        <div className="customer-egcare-table-sub-box">
                            <div className="customer-egcare-table-sub-title">보증 항목 제외</div>
                            <div className="customer-egcare-table-sub-title2">
                                다음 사항에 대해서는 보증수리를 제공하지 않습니다.
                            </div>
                            <div className="customer-egcare-table-sub-desc">① 일반적인 소모성, 유지성 부품의 교환</div>
                            <div className="customer-egcare-table-sub-desc">
                                ② 사용설명서의 안내에 따라 정기적인 차량 점검을 실시하지 않았거나 사용설명서가 정한
                                방법으로 사용하지 않아 발생한 고장.
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ③ 순정부품을 사용하지 않았거나 공식 서비스 망에서 수리하지 않아 발생한 고장
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ④ 천재지변, 도로사정, 개조, 임의조작, 구조변경 등의 사유로 발생한 고장
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ⑤ 사용상 부주의로 인한 보조 배터리 방전
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ⑥ 일반적인 오후 및 시간의 경과로 인해 발생하는 문제 (도장면 등의 자연 퇴색, 금속면 등의
                                녹, 소모품의 열화 등)
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ⑦ 기능상 문제가 아닌 개인의 주관적인 판단 (소리,진동 등)
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ⑧ 주행거리를 확인할 수 없거나 실제 주행거리를 판단할 수 없는 경우(주행거리 조작 포함)
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                ⑨ 차량임대 등 불특정 다수가 사용한 경우
                            </div>
                        </div>
                    </div>

                    <div className="customer-egcare-table-wrap">
                        <div className="customer-egcare-table-title">2. 부품보증</div>
                        <div className="customer-egcare-table-box">
                            <img className="customer-egcare-price-table-img pc" src={IMG_7_1} alt="부품보증 표" />
                            <img className="customer-egcare-price-table-img pad" src={IMG_7_2} alt="부품보증 표" />
                            <img className="customer-egcare-price-table-img mobile" src={IMG_7_3} alt="부품보증 표" />
                            {/* <table className="customer-egcare-table">
                                <tbody>
                                    <tr>
                                        <th>보증차량</th>
                                        <th>보증기간</th>
                                        <th>보증대상</th>
                                    </tr>
                                    <tr>
                                        <td rowSpan={2}>Gogoro 부품</td>
                                        <td>부품교체일로부터 90일</td>
                                        <td>비소모성 부품 전체</td>
                                    </tr>
                                    <tr>
                                        <td>부품교체일로부터 1년</td>
                                        <td>타이어 압력 측정기, 하향등, 블랙박스 한정</td>
                                    </tr>
                                    <tr>
                                        <td>Gogoro 악세서리</td>
                                        <td colSpan={2}>설치일로부터 90일</td>
                                    </tr>
                                </tbody>
                            </table> */}
                        </div>
                        <div className="customer-egcare-table-sub-box">
                            <div className="customer-egcare-table-sub-desc">
                                - {COMPANY_NAME_KO} 서비스망에서 교체 혹은 설치 받으시고 입력된 정비일자를 기준으로
                                보증합니다.
                            </div>
                            <div className="customer-egcare-table-sub-desc">
                                - 교체나 설치가 필요없는 일부 액세서리의 경우 구매일을 기준으로 보증합니다.(구매
                                증빙서류 필요)
                            </div>
                        </div>
                    </div>

                    {/* <div className="customer-egcare-table-wrap">
                        <div className="customer-egcare-table-title">3. 보증연장 상품</div>
                        <div className="customer-egcare-table-sub-box">
                            <div className="customer-egcare-table-sub-desc">
                                - 닷스테이션이 제공하는 무상 보증기간 만료 전, 보증연장 상품을 구입하면 기간/주행거리
                                동안 보증 기간을 연장하는 서비스입니다.
                            </div>
                        </div>
                        <img className="customer-egcare-chart-img pc" src={IMG_5_1} alt="차트" />
                        <img className="customer-egcare-chart-img pad" src={IMG_5_2} alt="차트" />
                        <img className="customer-egcare-chart-img mobile" src={IMG_5_3} alt="차트" />
                        <div className="customer-egcare-table-sub-desc" ref={secondImgRef}>
                            - 상품가격은 {COMPANY_NAME_KO} 판매점으로 문의 바랍니다.
                            <br />- 신차계약 차량만 가입 가능합니다.
                            <br />- 차량에 대한 보증으로 양도나 매매에 따른 소유자 변경시에도 동일하게 해당 차량에만
                            적용됩니다.
                            <br />- 닷스테이션이 제공하는 무상 보증기준과 동일하게 적용됩니다.(소모/유지성 부품은 제외)
                        </div>
                    </div> */}
                </div>

                <div className="customer-egcare-wrap-three">
                    <CustomerTitle
                        title="정기점검"
                        sub="고고로 차량이 최상의 상태를 유지할 수 있도록 점검기준에 따라 정기점검이 필요합니다."
                    />
                    <div className="customer-egcare-table-wrap">
                        {/* <div className="customer-egcare-table-title">정기점검</div> */}
                        <div className="customer-egcare-table-box">
                            <img className="customer-egcare-price-table-img pc" src={IMG_8_1} alt="정기점검 대상 표" />
                            <img className="customer-egcare-price-table-img pad" src={IMG_8_2} alt="정기점검 대상 표" />
                            <img
                                className="customer-egcare-price-table-img mobile"
                                src={IMG_8_3}
                                alt="정기점검 대상 표"
                            />
                        </div>
                    </div>
                </div>

                <div className="customer-egcare-wrap-four" /*  ref={fourthImgRef} */>
                    <CustomerTitle
                        title="표준공임"
                        sub={`${COMPANY_NAME_KO} 고고로 차량 정비시 아래와 같이 공임가격이 책정됩니다.`}
                    />

                    <div className="customer-egcare-table-wrap">
                        <div className="customer-egcare-table-title">시간당 정비공임</div>
                        <div className="customer-egcare-table-box">
                            <img
                                className="customer-egcare-price-table-img pc"
                                src={IMG_10_1}
                                alt="시간당 정비공임 표"
                            />
                            <img
                                className="customer-egcare-price-table-img pad"
                                src={IMG_10_2}
                                alt="시간당 정비공임 표"
                            />
                            <img
                                className="customer-egcare-price-table-img mobile"
                                src={IMG_10_3}
                                alt="시간당 정비공임 표"
                            />
                            {/* <table className="customer-egcare-table">
                                <tbody>
                                    <tr className="text-center bg-gray">
                                        <th className="text-center">작업시간</th>
                                        <td>0.1시간 (6분)</td>
                                        <td>0.2시간 (12분)</td>
                                        <td>0.3시간 (18분)</td>
                                        <td>0.4시간 (24분)</td>
                                        <td>0.5시간 (30분)</td>
                                    </tr>
                                    <tr className="text-center bg-gray">
                                        <th className="text-center">공임(원)</th>
                                        <td>4,400</td>
                                        <td>8,800</td>
                                        <td>13,200</td>
                                        <td>17,600</td>
                                        <td>22,000</td>
                                    </tr>
                                    <tr className="text-center bg-gray">
                                        <th className="text-center">작업시간</th>
                                        <td>0.6시간 (36분)</td>
                                        <td>0.7시간 (42분)</td>
                                        <td>0.8시간 (48분)</td>
                                        <td>0.9시간 (54분)</td>
                                        <td>1.0시간 (60분)</td>
                                    </tr>
                                    <tr className="text-center bg-gray">
                                        <th className="text-center">공임(원)</th>
                                        <td>26,400</td>
                                        <td>30,800</td>
                                        <td>35,200</td>
                                        <td>39,600</td>
                                        <td>44,000</td>
                                    </tr>
                                </tbody>
                            </table> */}
                        </div>
                        <div className="customer-egcare-table-sub-box">
                            <div className="customer-egcare-table-sub-desc">- 공임은 부가세 포함 금액입니다.</div>
                            <div className="customer-egcare-table-sub-desc">
                                - Gogoro 차량에 대한 시간당 공임 금액으로 그 외 차종은 정비공임이 상이할 수 있습니다.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="customer-egcare-wrap-four" ref={fourthImgRef}>
                    <CustomerTitle
                        title="표준부품가격"
                        sub={`${COMPANY_NAME_KO} 고고로 차량 정비시 아래와 같이 표준부품가격이 책정됩니다.`}
                    />

                    <div className="customer-egcare-table-wrap">
                        <div className="customer-egcare-table-title">표준부품가격</div>
                        <div className="customer-egcare-wrap-four-table-bikeType-wrap">
                            <Form.Select onChange={e => partsBikeTypeClick(e)}>
                                {PARTS_BIKE_DATA.map(val => (
                                    <option>{val?.BIKE_TYPE_NM}</option>
                                ))}
                            </Form.Select>
                        </div>
                        <div className="customer-egcare-table-box">
                            <table className="customer-egcare-table pc">
                                <colgroup>
                                    <col width="3%" />
                                    <col width="20%" />
                                    <col width="15%" />
                                    <col width="22%" />
                                    <col width="17%" />
                                    <col width="13%" />
                                    <col width="10%" />
                                </colgroup>
                                <thead>
                                    <tr className="text-center">
                                        <th className="text-center">번호</th>
                                        <th className="text-center">모델명</th>
                                        <th className="text-center">내용</th>
                                        <th className="text-center">부품번호</th>
                                        <th className="text-center">부품명</th>
                                        <th className="text-center">권장소비자가격 (V.A.T포함)</th>
                                        <th className="text-center">적용일자</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginationData?.data?.length > 0 ? (
                                        <>
                                            {paginationData?.data?.map(val => (
                                                <tr className="text-center" key={`parts-table-${val?.rowNum}`}>
                                                    <td>{val?.rowNum}</td>
                                                    <td>{nullReturn(val?.bikeTypeNm, '-')}</td>
                                                    <td>{nullReturn(val?.spec, '-')}</td>
                                                    <td>{nullReturn(val?.itemCd, '-')}</td>
                                                    <td>{nullReturn(val?.itemNm, '-')}</td>
                                                    <td>{priceToString(val?.itemPrice)}</td>
                                                    <td>{val?.validFromDt}</td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr className="text-center">
                                            <td colSpan={7}>부품이 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <table className="customer-egcare-table pad_mobile">
                                <colgroup>
                                    <col width="10%" />
                                    <col width="40%" />
                                    <col width="25%" />
                                    <col width="25%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th className="text-center">번호</th>
                                        <th className="text-center">내용</th>
                                        <th className="text-center">권장소비자가격 (V.A.T포함)</th>
                                        <th className="text-center">적용일자</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginationData?.data?.length > 0 ? (
                                        <>
                                            {paginationData?.data?.map(val => (
                                                <tr className="text-center" key={`parts-table-${val?.rowNum}`}>
                                                    <td>{val?.rowNum}</td>
                                                    <td className="text-left vertical">
                                                        <div className="text-weight-600">
                                                            {nullReturn(val?.bikeTypeNm, '-')}
                                                        </div>
                                                        <div>{nullReturn(val?.spec, '-')}</div>
                                                        <div>{nullReturn(val?.itemCd, '-')}</div>
                                                        <div>{nullReturn(val?.itemNm, '-')}</div>
                                                    </td>
                                                    <td>{priceToString(val?.itemPrice)}</td>
                                                    <td>{val?.validFromDt}</td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr className="text-center">
                                            <td colSpan={4}>부품이 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="customer-egcare-table-pagination-wrap">
                            <Pagination
                                activePage={paginationData.activePage}
                                itemsCountPerPage={15}
                                totalItemsCount={paginationData.totalItemsCount}
                                pageRangeDisplayed={5}
                                prevPageText={'‹'}
                                nextPageText={'›'}
                                onChange={idx => paginationOnChnage(idx)}
                            />
                        </div>
                        <div className="customer-egcare-wrap-four-table-searchWrap">
                            <Form.Select onChange={e => partsSearchSelect(e)}>
                                {partsSearchOptions.map(val => (
                                    <option>{val?.label}</option>
                                ))}
                            </Form.Select>
                            <Form.Control
                                type="text"
                                placeholder="검색어를 입력해 주세요"
                                onChange={e => partsSearchInputChange(e)}
                                onKeyDown={e => partsSearchInputKeyDown(e)}
                            />
                            <Button variant="dark" onClick={() => partsSearchClick()}>
                                검색
                            </Button>
                        </div>
                        {/* <div className="customer-egcare-table-sub-box">
                            <div className="customer-egcare-table-sub-desc">- 공임은 부가세 포함 금액입니다.</div>
                            <div className="customer-egcare-table-sub-desc">
                                - Gogoro 차량에 대한 시간당 공임 금액으로 그 외 차종은 정비공임이 상이할 수 있습니다.
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerEgcare
